import * as $ from 'jquery';
import { apiBaseUrlAdmin } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";
import { EditPictureModel } from "../../pictures/models/PictureModel";
import {
    CollageTemplateModel, NewFeedEntryModel, NewFeedFilterModel
} from "../models/NewFeedModel";

export class NewFeedAdminService extends DefaultService {
    private baseUrl = `${apiBaseUrlAdmin}/newFeed`;

    public RouteGet = (id: number) => `${this.baseUrl}/get/${id}`;
    public get(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteSearch = () => `${this.baseUrl}/search`;
    public search(model: NewFeedFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteSearch(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: NewFeedEntryModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEdit = (id: number) => `${this.baseUrl}/edit/${id}`;
    public edit(id: number, model: NewFeedEntryModel): JQueryPromise<any> {
        return $.ajax(this.RouteEdit(id), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteChangeTemplate = (id: number) => `${this.baseUrl}/changeTemplate/${id}`;
    public changeTemplate(id: number, model: CollageTemplateModel): JQueryPromise<any> {
        return $.ajax(this.RouteChangeTemplate(id), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteActivate = (id: number, active: boolean) =>
        `${this.baseUrl}/activate/${id}?active=${active}`;

    public activate(id: number, active: boolean): JQueryPromise<any> {
        return $.ajax(this.RouteActivate(id, active), {
            type: 'put',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: number) => `${this.baseUrl}/delete/${id}`;
    public delete(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id), {
            type: 'delete',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteCreatePictures = (ownerId: number) =>
        `${this.baseUrl}/createPictures/${ownerId}`;

    public RouteEditPicture = (ownerId: number) =>
        `${this.baseUrl}/editPicture/${ownerId}`;

    public editPicture(ownerId: number, picture: EditPictureModel): JQueryPromise<any> {
        return $.ajax(this.RouteEditPicture(ownerId), {
            type: 'put',
            data: JSON.stringify(picture),
            contentType: 'application/json'
        });
    }

    public RouteEditPictures = (ownerId: number) =>
        `${this.baseUrl}/editPictures/${ownerId}`;

    public editPictures(ownerId: number, pictures: EditPictureModel[]): JQueryPromise<any> {
        return $.ajax(this.RouteEditPictures(ownerId), {
            type: 'put',
            data: JSON.stringify(pictures),
            contentType: 'application/json'
        });
    }

    public RouteGetPictures = (ownerId: number) =>
        `${this.baseUrl}/getPictures/${ownerId}`;

    public getPictures(ownerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetPictures(ownerId), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteDeletePicture = (ownerId: number, id: number) =>
        `${this.baseUrl}/deletePicture/${ownerId}?id=${id}`;

    public deletePicture(ownerId: number, id: number): JQueryPromise<any> {
        return $.ajax(this.RouteDeletePicture(ownerId, id), {
            type: 'delete',
            data: undefined,
            contentType: 'application/json'
        });
    }
}